// extracted by mini-css-extract-plugin
module.exports = {"fab":"styles_fab__3WZGI","plus":"styles_plus__3ecPk","icons":"styles_icons__Ru2ii","text":"styles_text__2TPaa","icon":"styles_icon__2e4GS"};